import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import RoomInformation from '../../RoomInformation';

import { isMobileOnly } from 'react-device-detect';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import { Popover } from '@material-ui/core';
import { IconInfo } from '../../IconSet';


const messages = defineMessages({
  roomInfoTooltip: { id: 'roomInfoTooltip' },
});


function RoomInfo(_props: {}) {
  const { formatMessage } = useIntl();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleRoomInfo = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const closeRoomInfo = (): void => {
    setAnchorEl(null);
  };

  const getIcon = () => {
    return (
      <IconInfo size={32} />
    );
  };

  const getMobileLayout = () => {
    return (
      <MenuItem onClick={handleRoomInfo}>
        <ListItemIcon>
          {getIcon()}
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.roomInfoTooltip)} />
      </MenuItem>
    );
  };

  const getLayout = () => {
    return (
      <Tooltip title={formatMessage(messages.roomInfoTooltip)}>
        <IconButton onClick={handleRoomInfo}>
          {getIcon()}
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <div>
      { isMobileOnly ? getMobileLayout() : getLayout() }
      <Popover
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={open}
        onClose={closeRoomInfo}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {<RoomInformation />}
      </Popover>
    </div>
  );
}


export default RoomInfo;
